const id = {
  templateInsightSent: "Pesan Terkirim",
  templateInsightDelivered: "Pesan Tersampaikan",
  templateInsightRead: "Pesan Dibaca",
  templateInsightReplied: "Pesan Dibalas",
};

const en = {
  templateInsightSent: "Messages Sent",
  templateInsightDelivered: "Messages Delivered",
  templateInsightRead: "Messages Read",
  templateInsightReplied: "Messages Replied",
};

export default { id, en };
